import Fieldset from './fieldset'

Fieldset.install = vue => {
  vue.component(Fieldset.name, Fieldset)
}

export default Fieldset
